export default __webpack_public_path__ + "static/media/hvacomdm140-3.3db65e32.webp";